import { useActiveWorkspace } from "hooks/useActiveWorkspace";
import { useScopedPersistedState } from "hooks/usePersistedState";

import type { Command } from "../../types";

export const useCodeiumFlag = () => {
  const workspace = useActiveWorkspace();

  const flag = useScopedPersistedState(
    "AI/CODE_COMPLETION",
    true,
    workspace?.id ?? "",
  );

  return flag;
};

export const useCodeiumCommand = (): Command => {
  const [codeCompletion, setCodeCompletion] = useCodeiumFlag();

  return {
    id: "codesandbox.settings.codeium",
    name: "Toggle Codeium auto completion",
    binding: "$mod+Alt+A",
    section: "Settings",
    perform: () => {
      setCodeCompletion(!codeCompletion);
    },
  };
};
